import { MyElement } from '@myprint/design/types/entity';

export const auxiliaryProvider: Array<MyElement> = [
    // {
    //     type: "Text",
    //     label: "标尺",
    //     data: "自定义文本",
    //     width: 30.25,
    //     height: 14.25
    // } as Element
];
